module.exports = __webpack_public_path__ + "static/media/gulp.460c8d91.png";